/* eslint-disable typescript/no-non-null-assertion --
 * Config variables should always be defined by either environment variables or the root node's dataset properties.
 */

import type { Debug, Features, Config } from "./types";
import { splitConfigFlags } from "../utilities/SplitConfigFlags";

const dataset = document.getElementById("sso-root")?.dataset ?? {};
const debug = splitConfigFlags<Debug>("debug");
const features = splitConfigFlags<Features>("features");

if (debug.verbose) {
    console.info("Debug variables:", debug);
    console.info("Feature flags:", features);
}
// Get the dataset property if it's not a comment (variable inject macro)
const qrInputUri = dataset.qrUrl?.match(/^<!--(?:(?!-->).)+-->$/) ? import.meta.env.VITE_QR_URL : dataset.qrUrl;

export const config: Config = {
    baseApi: import.meta.env.VITE_BASE_API ?? dataset.baseApi!,

    debug,
    features,
    qrURL: qrInputUri === "" ? undefined : qrInputUri,
    version: {
        number: import.meta.env.VITE_VERSION ?? dataset.version!,
        hash: import.meta.env.VITE_VERSION_HASH,
        env: import.meta.env.VITE_ENV ?? dataset.env!,
        productName: "Prowise SSO",
    },

    locizeProjectId: import.meta.env.VITE_LOCIZE_PROJECT_ID,
    locizeProjectVersion: import.meta.env.VITE_LOCIZE_PROJECT_VERSION,
    pictureLoginAttempts: import.meta.env.VITE_PICTURE_LOGIN_ATTEMPTS ?? dataset.pictureLoginAttempts,
    captchaPublicKey: import.meta.env.VITE_CAPTCHA_PUBLIC_KEY ?? dataset.captchaPublicKey,
    captchaProxyUrl: import.meta.env.VITE_CAPTCHA_PROXY_URL ?? dataset.captchaProxyUrl,
    app: {
        authority: import.meta.env.VITE_APP_AUTHORITY ?? dataset.appAuthority!,
        clientId: import.meta.env.VITE_APP_CLIENT_ID ?? dataset.appClientId!,
        url: import.meta.env.VITE_APP_URL ?? dataset.appUrl,
    },
};
